/**
 * Created by WebStorm.
 * User: Mehedi Hasan
 * Date: 09 Jan 2025
 * Time: 10:17 AM
 * Email: mdmehedihasanroni28@gmail.com
 */

import * as URL from "../helpers/Constants";
import axios from "axios";

export default class SubscriptionCouponService {

    static getAllSubscriptionCoupon(params) {
        return axios.get(URL.GET_ALL_SUBSCRIPTION_COUPON_URL, {
                params,
                ...SubscriptionCouponService.getAuthHeader(),
            }
        );
    }

    static getSubscriptionCoupon(id) {
        return axios.get(`${URL.GET_SUBSCRIPTION_COUPON_URL}/${id}`, {
                ...SubscriptionCouponService.getAuthHeader()
            }
        );
    }

    static addSubscriptionCoupon(data) {
        return axios.post(URL.ADD_SUBSCRIPTION_COUPON_URL, data, {
                ...SubscriptionCouponService.getAuthHeader()
            }
        );
    }

    static editSubscriptionCoupon(id, data) {
        return axios.put(`${URL.EDIT_SUBSCRIPTION_COUPON_URL}/${id}`, data, {
                ...SubscriptionCouponService.getAuthHeader()
            }
        );
    }

    static applyCoupon(id, params) {
        return axios.get(`${URL.APPLY_SUBSCRIPTION_COUPON_URL}/${id}`, {
                params,
                ...SubscriptionCouponService.getAuthHeader()
            }
        );
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        const options = {headers: {"Authorization": `Bearer ${accessToken}`}}
        return options;
    }

}